// src/components/common/Legend.jsx
//
// Labeled rows of [color square] [text] items. Shared across pages.
// Uses CSS Grid so items align vertically across rows.
// All sizing via CSS variables so a client can restyle in one place.

import React from 'react';

export default function Legend({ rows }) {
  const hasAnyLabel = rows.some(r => r.label);
  const maxCols = Math.max(0, ...rows.map(r => r.items.length));
  const columns = hasAnyLabel
    ? `var(--legend-label-width) repeat(${maxCols}, auto)`
    : `repeat(${maxCols}, auto)`;

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: columns,
      columnGap: 'var(--legend-col-gap)',
      rowGap: 'var(--legend-row-gap)',
      alignItems: 'center',
      justifyItems: 'start',
    }}>
      {rows.map((row, i) => (
        <React.Fragment key={i}>
          {hasAnyLabel && (
            row.label ? (
              <span style={{
                fontSize: 'var(--legend-font-size)',
                fontWeight: 600,
                color: 'var(--text-secondary)',
              }}>
                {row.label}
              </span>
            ) : (
              <span />
            )
          )}
          {row.items.map((item, j) => (
            <span key={j} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--legend-item-gap)',
            }}>
              <span style={{
                width: 'var(--legend-square-size)',
                height: 'var(--legend-square-size)',
                borderRadius: 'var(--legend-square-radius)',
                background: item.color,
                flexShrink: 0,
              }} />
              <span style={{
                fontSize: 'var(--legend-font-size)',
                color: 'var(--text-secondary)',
              }}>
                {item.text}
              </span>
            </span>
          ))}
          {Array.from({ length: maxCols - row.items.length }).map((_, k) => (
            <span key={`pad-${k}`} />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}